exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cs-browser .ant-input-group-addon {\n  cursor: pointer;\n  padding: 0;\n}\n.cs-browser .ant-input-group-addon .anticon-search {\n  padding: 4px 8px;\n}\n.cs-browser-Modal .ant-modal-body {\n  padding: 0;\n}\n.cs-browser-Modal-search {\n  text-align: right;\n  border-bottom: 1px solid #e8e8e8;\n  padding: 10px 0;\n  margin-right: 10px;\n}\n.cs-browser-Modal-search .ant-input-search {\n  width: 300px;\n}\n.ant-modal-mask {\n  background: rgba(55, 55, 55, 0.6);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1DA57A"}}!./src/components/public/cs-browser/style/index.less
// module id = 1385
// module chunks = 0